import styled from '@emotion/styled';
import { theme } from 'styles/theme';

export const Icon = styled.i`
  font-style: normal;
  display: block;
  width: 4rem;
  & * {
    fill: ${theme.colors.blueGreen};
  }
`;